(function () {
    'use strict';

    angular.module('imnApp').controller('BridgeAddController', BridgeAddController);

    BridgeAddController.$inject = [
        '$scope',
        '$rootScope',
        '$filter',
        '$q',
        '$uibModalInstance',
        '$translate',
        'BridgeService',
        'OltService',
        'OnuService',
        'GtpService',
        'PacketRuleService',
        'bridgeId',
        'bridgeData'
    ];

    function BridgeAddController(
        $scope,
        $rootScope,
        $filter,
        $q,
        $uibModalInstance,
        $translate,
        BridgeService,
        OltService,
        OnuService,
        GtpService,
        PacketRuleService,
        bridgeId,
        bridgeData
    ) {
        var vm = this;

        vm.showAlertVisible = false;
        vm.showAlertMessage = '';

        vm.isAdvanced = true;
        vm.isEdit = !!bridgeId;
        vm.fromSimple = !!bridgeData;
        var isNew = (!vm.fromSimple && !vm.isEdit) || vm.fromSimple;
        //var isNew = (!vm.fromSimple && !vm.isEdit);


        vm.modalTitle = vm.isEdit ? 'edit' : 'add';
        vm.buttonLabel = vm.isEdit ? 'save' : 'add';

        // Flag to avoid closing modal when request is running
        vm.requestRunning = false;

        // Comboboxes content
        vm.oltList = [];
        vm.onuList = [];
        vm.typesList = [];
        vm.portList = [];
        vm.multicastList = [];
        vm.packetRuleList = [];
        vm.gtpList = [];
        vm.rgModeList = [];
        vm.ipModeList = [];
        vm.ipProfileList = [];
        vm.serverProfileList = [];
        vm.featuresProfileList = [];
        vm.featuresStaticProfileList = [];
        vm.mediaProfileList = [];
        vm.zhoneFeaturesList = [];
        vm.cpeVoipIpProfileList = [];

        // Comboboxes and radio buttons actions
        vm.setInterface = setInterface;
        vm.setOlt = setOlt;
        vm.setPort = setPort;
        vm.setOnu = setOnu;
        vm.setType = setType;
        vm.setService = setService;
        vm.setGtp = setGtp;
        vm.setRgMode = setRgMode;
        vm.setProfile = setProfile;
        vm.setIpMode = setIpMode;
        vm.setUniPort = setUniPort;
        vm.cpeVoipIpProfile = null;

        vm.serverProfile = '';
        vm.featuresProfile = '';
        vm.mediaProfile = '';
        vm.profileFeature = '';
        vm.zhoneFeatures = '';
        vm.enderecoIp = '';

        // Form actions
        vm.close = close;
        vm.save = save;

        // Form model
        vm.bridge = {};

        // Return the path of the partial view
        vm.partial = partial;

        // Show fields according to the option of RG Mode or IP Mode selected
        vm.checkRgMode = checkRgMode;
        vm.isWifi = isWifi;
        vm.is8820G = isOlt8820G;
        vm.isLanPortDisabled = isLanPortDisabled;

        vm.changeConfigIndex = changeConfigIndex;
        vm.changeModoRouted = changeModoRouted;
        vm.validateSaveSipFx = validateSaveSipFx;

        // Get validation rules
        var validationRules = BridgeService.getValidationRules();
        var fxsValidationRules = BridgeService.getFxsValidationRules();

        // Input select reference
        var selectReference = {
            selectOltPort: null,
            selectOnu: null
        };

        initialize();

        // Action Functions

        // Set interface as OLT or ONU
        function setInterface() {
            var selectedInterface = vm.bridge.interface.value;

            // When occur the changing in the interface option, the select olt port will be reset.
            if (selectReference.selectOltPort) {
                resetSelectIndex('selectOltPort');
            }
            // Clear port combo
            vm.bridge.port.model = '';

            // Clear and disable ONU combo
            vm.bridge.onu.model = '';
            vm.bridge.onu.disabled = true;

            // Check if the bridge type selected for the previous interface does not exist
            // for the new interface selected, if it doesn't exist, select the first option
            checkType();

            // Actions that are specific to each interface
            switch (selectedInterface) {
                case 'OLT':
                    // Disable the video service
                    vm.bridge.video.disabled = true;

                    // Disable the voice service
                    vm.bridge.voice.disabled = true;

                    // Hide the ONU Interface column
                    vm.bridge.onuInterface.hidden = true;

                    // If video or voice is selected, change to data
                    if (vm.bridge.service != 'data') {
                        setService('data');
                    }

                    // Disable config ONU (wifi) button
                    vm.bridge.wlan.disabled = true;

                    // Change the size of the modal in order to hide the "ONU Interface" column
                    vm.modalSize = '';

                    break;

                case 'ONU':
                    // Clear GEM port
                    vm.bridge.gemPort.value = '';

                    // There is no untagged mode for ONU
                    // if untagged is selected, change to tagged
                    if (vm.bridge.vlanMode == 'untagged') {
                        vm.bridge.vlanMode = 'tagged';
                    }

                    // Enable the video service
                    vm.bridge.video.disabled = false;

                    // Show the ONU Interface column
                    vm.bridge.onuInterface.hidden = false;

                    // Clear RG mode
                    vm.bridge.rgMode.model = {label: 'OMCI', value: ''};
                    setRgMode(vm.bridge.rgMode.model);
                    vm.bridge.rgMode.disabled = true;

                    // Change the size of the modal in order to show the "ONU Interface" column
                    vm.modalSize = 'modal-xl';

                    break;
            }

            isStpDisabled();
        }

        function validateSaveSipFxCheckOne() {
            var fxs0Nao = !vm.bridge.fxs[0].username && !vm.bridge.fxs[0].password;
            var fxs1Nao = !vm.bridge.fxs[1].username && !vm.bridge.fxs[1].password;
            if (fxs0Nao && fxs1Nao)
                return true;
        }

        function validateSaveSipFx(porta) {
            if (
                ((vm.bridge.fxs[porta - 1].username && vm.bridge.fxs[porta - 1].password) ||
                    (!vm.bridge.fxs[porta - 1].username && !vm.bridge.fxs[porta - 1].password)) &&
                !validateSaveSipFxCheckOne()
            )
                return false;
            return true;
        }

        function changeConfigIndex(modoVoip) {
            vm.serverProfile = '';
            vm.featuresProfile = '';
            vm.mediaProfile = '';
            vm.profileFeature = '';
            vm.zhoneFeatures = '';
            /*
             vm.bridge.fxs.forEach(function(item, index, fxs) {
             fxs[index].serverProfile = '';
             fxs[index].featuresProfile = '';
             fxs[index].mediaProfile = '';
             }); */

            // Clean the fxs ports
            vm.bridge.fxs.forEach(function (port) {
                port.enablePort = false;
                port.dialNumber = '';
                port.username = '';
                port.password = '';
                port.rxGain = 0;
                port.txGain = 0;
            });
        }

        // On select OLT
        function setOlt(selectedOlt) {
            // When occur the changing in the olt option, the select onu will be reset.
            if (selectReference.selectOnu) {
                resetSelectIndex('selectOnu');
            }

            isStpDisabled();

            // Reload the types list according to the selected OLT
            BridgeService.getTypes(selectedOlt.model, null)
                // Apply the content to the list model
                .then(setList('typesList'))
                // Check if the bridge type selected for the previous interface does not exist
                // for the new interface selected, if it doesn't exist, select the first option
                .then(checkType);

            if (isNew) {
                // Clear port combo
                if (vm.bridge.port.model !== '') {
                    vm.bridge.port.model = '';
                }

                // Enable the port combo when an OLT is selected
                BridgeService.getPorts(vm.bridge.olt.model.model).then(setList('portList'));
                vm.bridge.port.disabled = false;
                vm.bridge.port.placeholder = 'global.common.select';
                setPort(vm.bridge.port.model);

                // Clear MCL
                vm.bridge.multicastList.model = {};

                // Clear GTP
                vm.bridge.gtp.model = {};

                // Clear IP Profile
                vm.bridge.ipProfile.model = '';

                // Clear Packet Rule
                vm.bridge.iPacketRule.model = {};
                vm.bridge.ePacketRule.model = {};
            }

            // Load multicast, gtp and packet rule lists according to the selected OLT
            // When editing these content are loaded on get bridge callback
            if (!vm.isEdit) {
                getMulticastLists(selectedOlt.id, true)
                    .then(setMcl)
                    .catch(close);
                getGtpList(selectedOlt.id, true)
                    .then(setGtp)
                    .catch(close);
                PacketRuleService.listGroups(selectedOlt.id, true)
                    .then(successPacketRuleList)
                    .catch(close);
            }

            // Apply validation rules and tooltip according to the selected OLT
            angular.forEach(validationRules[selectedOlt.model], function (ruleValue, ruleName) {
                angular.forEach(ruleValue, function (value, key) {
                    vm.bridge[ruleName][key] = value;
                });
                $translate('tooltip.' + ruleName, vm.bridge[ruleName]).then(setTooltip(ruleName));
            });

            // Apply FXS validation pattern and tooltip according to the selected OLT
            vm.fxsCredentials.pattern = fxsValidationRules[selectedOlt.model].credentials.pattern;
            $translate('tooltip.accessUser.' + selectedOlt.model).then(setFxsTooltip('username'));
            $translate('tooltip.accessPassword.' + selectedOlt.model).then(setFxsTooltip('password'));
        }

        // Set the selected port
        function setPort(selectedPort, $select) {
            // Get the olt select reference and stored in a variable for be handler.
            if (selectReference.selectOltPort == null && $select != null) {
                setSelectReference('selectOltPort', $select);
            }

            // When occur the changing in the olt port option, the select onu will be reset.
            if (selectReference.selectOnu) {
                resetSelectIndex('selectOnu');
            }

            // Clear and request the ONU list filtered by OLT and port
            if (selectedPort && selectedPort.value && vm.bridge.interface.value == 'ONU') {
                var data = {
                    oltId: vm.bridge.olt.model.id,
                    gponPort: selectedPort.value
                };

                // Clear ONU list and ONU model
                vm.onuList = [];
                vm.bridge.onu.model = '';
                vm.bridge.onu.disabled = true;
                vm.bridge.onu.placeholder = 'global.common.loading';

                // Disable Voice Service
                vm.bridge.voice.disabled = true;

                // If voice is selected, change to data
                if (!vm.isEdit && vm.bridge.service == 'voice') {
                    setService('data');
                }

                disableSave();
                //OnuService.getAuthorizedOnuList(data, true).then(successOnuList);
                OnuService.getAuthorizedOnuVmList(data, true).then(successOnuList);

                // Clear RG Mode
                vm.bridge.rgMode.model = {label: 'OMCI', value: ''};
                setRgMode(vm.bridge.rgMode.model);
                vm.bridge.rgMode.disabled = true;
            }
        }

        // Set the selected ONU
        function setOnu(selectedOnu, $select) {
            // Get the onu select reference and stored in a variable for be handler.

            if (selectReference.selectOnu == null && $select != null) {
                setSelectReference('selectOnu', $select);
            }
            // Check features that depend on ONU model
            var meProfile = selectedOnu.meProfile;

            //SOU-249 SOU-236
            //var portModel = 
            if (vm.fromSimple && (selectedOnu != null && $select == null)) {
                if (meProfile == 'Intelbras110') {
                    meProfile = 'intelbras-110';
                } else if (meProfile == 'Intelbras110b') {
                    meProfile = 'intelbras-110b';
                } else if (meProfile == 'Intelbras110g') {
                    meProfile = 'intelbras-110g';
                } else if (meProfile == 'Intelbras110gi') {
                    meProfile = 'intelbras-110gi';
                } else if (meProfile == 'Intelbras120ac') {
                    meProfile = 'intelbras-120ac';
                } else if (meProfile == 'Intelbras121ac') {
                    meProfile = 'intelbras-121ac';
                } else if (meProfile == 'Intelbras121w') {
                    meProfile = 'intelbras-121w';
                } else if (meProfile == 'Intelbras1200r') {
                    meProfile = 'intelbras-1200r';
                } else if (meProfile == 'Intelbras1420g') {
                    meProfile = 'intelbras-1420g';
                } else if (meProfile == 'Intelbras142ng') {
                    meProfile = 'intelbras-142ng';
                } else if (meProfile == 'Intelbras142nw') {
                    meProfile = 'intelbras-142nw';
                } else if (meProfile == 'Intelbrasax1800') {
                    meProfile = 'intelbras-ax1800';
                } else if (meProfile == 'Intelbrasax1800v') {
                    meProfile = 'intelbras-ax1800v';
                } else if (meProfile == 'IntelbrasR1') {
                    meProfile = 'intelbras-r1';
                } else if (meProfile == 'Default') {
                    meProfile = 'intelbras-default';
                } else {
                    meProfile = 'intelbras-110';
                }
                vm.bridge.port = {
                    model: {
                        label: 'Gpon ' + selectedOnu.gponPort,
                        value: selectedOnu.gponPort,
                        type: 'GPON'
                    }
                }
                vm.bridge.onu.model.meProfile = meProfile;
            }

            var noRgMode =
                !(meProfile === 'intelbras-110' && vm.bridge.olt.model.model === 'Intelbras8820i') &&
                meProfile != 'intelbras-110gi' &&
                meProfile != 'intelbras-120ac' &&
                meProfile != 'intelbras-121ac' &&
                meProfile != 'intelbras-121w' &&
                meProfile != 'intelbras-1200r' &&
                meProfile != 'intelbras-142ng' &&
                meProfile != 'intelbras-142nw' &&
                meProfile != 'intelbras-ax1800' &&
                meProfile != 'intelbras-ax1800v' &&
                meProfile != 'intelbras-1420g' &&
                meProfile != 'intelbras-r1' &&
                meProfile != 'intelbras-default';

            console.log("disable rgMode: ", noRgMode);
            // Enable or disable RG Mode according to the selected ONU
            vm.bridge.rgMode.disabled = noRgMode;

            var noVoice = meProfile != 'intelbras-142ng' && meProfile != 'intelbras-1420g' && meProfile != 'intelbras-ax1800v' && meProfile != 'intelbras-default';

            // Enable or disable Voice Service according to the selected ONU
            vm.bridge.voice.disabled = noVoice;

            //console.log('meProfile==>' + meProfile);
            var noVideo = meProfile == 'intelbras-142nw' || meProfile == 'intelbras-121w';
            // Enable the video service
            vm.bridge.video.disabled = noVideo;

            // Get RG Modes by model and meProfile
            if (vm.bridge.olt.model.model === 'Intelbras8820i') {
                BridgeService.getRgModesIntelbras(meProfile).then(setList('rgModeList'));
            } else {
                BridgeService.getRgModesOLT8820G(meProfile).then(setList('rgModeList'));
            }

            if (isNew) {


                // If voice is selected, but ONU has no voice service, change to data
                if (noVoice && vm.bridge.service == 'voice') {
                    setService('data');
                }

                // Clear RG Model
                if ((vm.bridge.olt.model.model !== 'Intelbras8820i') &&
                    (meProfile === 'intelbras-1420g' || meProfile === 'intelbras-142ng' || meProfile === 'intelbras-default')) {
                    vm.bridge.rgMode.model = {label: 'Roteamento (RG)', value: 'RG_ROTEAMENTO'};
                } else {
                    vm.bridge.rgMode.model = {label: 'OMCI', value: ''};
                }
            } else {
                // If is edit or coming from simple, apply the actions according to the selected service
                setService();
            }

            // Apply the actions according to the selected RG Mode

            setRgMode(vm.bridge.rgMode.model);

        }

        // Set the selected type
        function setType(selectedType) {
            vm.bridge.type = selectedType;

            // Actions that are specific to each type
            if (vm.bridge.interface.value == 'OLT') {
                // Only Uplink has video service for OLT
                if (selectedType.value == 'UPLINK') {
                    // Enable the video service
                    vm.bridge.video.disabled = false;
                } else {
                    // Disable the video service
                    vm.bridge.video.disabled = true;
                    // If video is selected, change to data
                    if (vm.bridge.service == 'video') {
                        setService('data');
                    }
                }

                // Bridge Rlink must use STP
                if (selectedType.value == 'RLINK') {
                    // Check and disable the STP switch
                    vm.bridge.stp.value = true;
                    vm.bridge.stp.disabled = true;
                } else {
                    // Uncheck and enable the STP switch
                    vm.bridge.stp.value = false;
                    vm.bridge.stp.disabled = false;
                }
            }
        }

        // Check if the bridge type selected for the previous interface does not exist for
        // the new interface selected, if it doesn't exists, it selects the first option
        function checkType() {
            var selectedInterface = vm.bridge.interface.value;
            if (!$filter('filter')(vm.typesList[selectedInterface], vm.bridge.type.value, true).length) {
                setType(vm.typesList[selectedInterface][0]);
            }
        }

        // Set the selected service
        function setService(service) {
            // If a service is received as an argument, use it
            if (service) {
                vm.bridge.service = service;
            }

            // Enable WLAN Ports and don't show the button 'Add Bridge and Config Wifi'
            setRgMode(vm.bridge.rgMode.model);

            // Actions that are specific to each type
            if (vm.bridge.service == 'video') {
                // Check the IGMP Proxy switch
                vm.bridge.igmpProxy.value = true;
                // Enable the IGMP Send IP input
                vm.bridge.igmpSendIp.disabled = false;

                // If there's an OLT selected, enable the Multicast Control List input
                setMcl();
                // Enable the maximum multicast streams input
                vm.bridge.maxMulticastStreams.disabled = false;
            } else {
                // Uncheck the IGMP Proxy switch
                vm.bridge.igmpProxy.value = false;
                // Disable the IGMP Send IP input
                vm.bridge.igmpSendIp.disabled = true;

                // Disable the Multicast Control List input
                vm.bridge.multicastList.disabled = true;
                // Disable the maximum multicast streams input
                vm.bridge.maxMulticastStreams.disabled = true;

                if (vm.bridge.service == 'voice') {
                    if (!vm.isEdit) {
                        // Clean the fxs ports
                        vm.bridge.fxs.forEach(function (port) {
                            port.enablePort = false;
                            port.dialNumber = '';
                            port.username = '';
                            port.password = '';
                            port.rxGain = 0;
                            port.txGain = 0;
                            //port.serverProfile = '';
                            //port.featuresProfile = '';
                            //port.mediaProfile = '';
                            //port.zhoneFeatures = '';
                        });

                        // Clear the model and reload Profile list according to the selected OLT
                        /*
                         vm.bridge.fxs.forEach(function(item, index, fxs) {
                         fxs[index].serverProfile = '';
                         fxs[index].featuresProfile = '';
                         fxs[index].mediaProfile = '';
                         fxs[index].zhoneFeatures = '';
                         }); */

                        vm.serverProfile = '';
                        vm.featuresProfile = '';
                        vm.mediaProfile = '';
                        vm.profileFeature = '';
                        vm.zhoneFeatures = '';
                    }

                    // Load the profiles
                    vm.bridge.profiles.placeholder = 'global.common.loading';
                    vm.serverProfileList = [];
                    vm.featuresProfileList = [];
                    vm.featuresStaticProfileList = [];
                    vm.mediaProfileList = [];
                    vm.zhoneFeaturesList = [];
                    disableSave();
                    BridgeService.getSipProfiles(vm.bridge.olt.model.id)
                        .then(successSipProfilesList)
                        .catch(function () {
                            enableSave();
                            close();
                        });

                    if (vm.enderecoIp != '0.0.0.0') {
                        BridgeService.getCpeVoipProfiles(vm.bridge.olt.model.id, vm.bridge.olt.model.model, vm.enderecoIp)
                            .then(successCpeVoipProfilesList)
                            .catch(function () {
                                enableSave();
                                close();
                            });
                    } else {
                        BridgeService.getCpeVoipProfiles(vm.bridge.olt.model.id, vm.bridge.olt.model.model)
                            .then(successCpeVoipProfilesList)
                            .catch(function () {
                                enableSave();
                                close();
                            });
                    }

                    // Select the first port
                    vm.selectedFxs = 1;

                    // Disable WLAN Ports and don't show the button 'Add Bridge and Config Wifi'
                    vm.bridge.wlan.disabled = true;
                }
            }

            // Show/hide ONU Interface according to the selected service
            if (vm.bridge.interface.value == 'ONU') {
                vm.bridge.onuInterface.hidden = vm.bridge.service == 'voice';
            }
        }

        // Set the selected MCL
        function setMcl() {
            // If there's an OLT selected, enable the MCL field
            if (vm.bridge.service == 'video' && vm.bridge.olt.model.id && vm.multicastList.length) {
                vm.bridge.multicastList.disabled = false;
            } else {
                vm.bridge.multicastList.disabled = true;
            }
        }

        // Set the selected GTP
        function setGtp() {
            // If there's an OLT selected, enable the GTP field
            if (!vm.bridge.gtp.automatic && vm.bridge.olt.model.id && vm.gtpList.length) {
                vm.bridge.gtp.disabled = false;
            } else {
                vm.bridge.gtp.disabled = true;
            }
        }

        // Set the RG Mode selected
        function setRgMode(rgMode) {
            var promise = null;

//            console.log('rgMode-----------', rgMode.value);
//
//            console.log('isOlt8820i()-------------' + isOlt8820i());
//            console.log('isOnu110()-------------' + isOnu110());
//            console.log('isOnu110G()-------------' + isOnu110G());
//            console.log('isOnu110Gi()-------------' + isOnu110Gi());
//            console.log('isOnuR1()-------------' + isOnuR1());
//            console.log('isOnu121ac()-------------' + isOnu121ac());
//            console.log('isOnu1420g()-------------' + isOnu1420g());

            switch (rgMode.value) {
                case '':
                    // Lan Ports must only be enabled on OMCI mode if there's an OLT and
                    // an ONU selected and if the selected OLT is an 8820i model
                    vm.bridge.lanPort.disabled = !vm.bridge.onu.model || isOnuUnknown() || !isOlt8820i();

                    // Wlan ports and Lan Mode fields are disabled in OMCI mode
                    vm.bridge.wlan.disabled = true;
                    vm.bridge.onuInterface.disabled = true;

                    // If is not edit select only the first LAN port

                    if (vm.isEdit && (isOnu121w() || isOnu120ac() || isOnu121ac() || isOnu1200r() || isOnuax1800() || isOnuax1800v() || isOnu142nw())) {
                        vm.bridge.lanPort.disabled = false;
                    } else if (!vm.isEdit) {
                        vm.bridge.lanPort.model[1] = true;
                        if (isOnu121w() || isOnu120ac() || isOnu121ac() || isOnu1200r()) {
                            vm.bridge.lanPort.disabled = false;
                            vm.bridge.lanPort.model[2] = true;
                            vm.bridge.lanPort.model[3] = false;
                            vm.bridge.lanPort.model[4] = false;
                        } else if (isOnu142nw() || isOnuax1800() || isOnuax1800v()) {
                            vm.bridge.lanPort.disabled = false;
                            vm.bridge.lanPort.model[2] = true;
                            vm.bridge.lanPort.model[3] = true;
                            vm.bridge.lanPort.model[4] = true;
                        } else if (isOlt8820i()) {
                            vm.bridge.lanPort.model[2] = !(isOnu110() || isOnu110G() || isOnu110Gi() || isOnuR1());
                            vm.bridge.lanPort.model[3] = !(isOnu110() || isOnu110G() || isOnu110Gi() || isOnuR1());
                            vm.bridge.lanPort.model[4] = !(isOnu110() || isOnu110G() || isOnu110Gi() || isOnuR1());
                        }
                    }

                    BridgeService.getTypes().then(setList('typesList'));

                    break;

                case 'RG_BROUTED_ITBS':
                    vm.bridge.lanPort.disabled = true;
                    vm.bridge.wlan.disabled = true;
                    vm.bridge.onuInterface.disabled = true;
                    BridgeService.getTypes().then(setList('typesList'));

                    break;

                case 'RG_ROTEAMENTO':
                    //Interface OLT
                    BridgeService.getTypes(null, rgMode.value).then(setList('typesList'));

                    //Configurações de Vídeo
                    vm.bridge.maxMulticastStreams.disabled = true;

                    //Regras de Pacotes
                    vm.bridge.iPacketRule.disabled = true;
                    vm.bridge.ePacketRule.disabled = true;

                    //Interface ONU
                    vm.bridge.onuInterface.disabled = true;
                    vm.bridge.lanPort.disabled = true;
                    vm.bridge.wlan.disabled = true;

                    break;

                case 'RG_BROUTED':
                    // Disable/enable RG Mode Routed fields according to the selected OLT
                    vm.bridge.ipProfile.disabled = isOnuUnknown() || isOlt8820i(); // Disabled for Intelbras
                    vm.bridge.ipMode.disabled = isOnuUnknown() || isOlt8820G(); // Disabled for Zhone
                    vm.bridge.ipAddress.disabled = true;
                    vm.bridge.subnetMask.disabled = true;
                    vm.bridge.gateway.disabled = true;

                    // Clear RG Mode Routed fields
                    vm.bridge.ipProfile.model = '';
                    vm.bridge.ipMode.model = '';
                    vm.bridge.ipAddress.value = '';
                    vm.bridge.subnetMask.value = '';
                    vm.bridge.gateway.value = '';

                    // Load Profile list according to the selected OLT
                    promise = getIpProfiles(vm.bridge.olt.model.id);

                // Falls through
                default:
                    // Check features that depend on ONU model

                    var meProfile = vm.bridge.onu.model.meProfile;
                    var noWlan = meProfile != 'intelbras-142ng';

                    if (!isOnuUnknown()) {
                        // LAN ports are always enabled for modes other than OMCI
                        vm.bridge.lanPort.disabled = false;
                    }

                    // Disable WLAN ports according to the selected ONU
                    vm.bridge.wlan.disabled = noWlan;

                    // LAN mode fields are always enabled for modes other than OMCI
                    if (!isOnuUnknown()) {
                        vm.bridge.onuInterface.disabled = false;
                    }

                    // Check all lan ports if it is not editing
                    if (!vm.isEdit) {
                        if (isOlt8820i()) {
                            vm.bridge.lanPort.model[1] = false;
                            vm.bridge.lanPort.model[2] = false;
                            vm.bridge.lanPort.model[3] = false;
                            vm.bridge.lanPort.model[4] = false;
                        } else {
                            vm.bridge.lanPort.model[1] = true;
                            vm.bridge.lanPort.model[2] = !(isOnu110() || isOnu110G() || isOnu110Gi() || isOnuR1());
                            vm.bridge.lanPort.model[3] = !(isOnu110() || isOnu110G() || isOnu110Gi() || isOnuR1());
                            vm.bridge.lanPort.model[4] = !(isOnu110() || isOnu110G() || isOnu110Gi() || isOnuR1());
                        }
                    }

                    BridgeService.getTypes().then(setList('typesList'));
            }
            setUniPort();
            return promise || $q.resolve();
        }

        // Set the Profile selected
        function setProfile(selectedProfile) {
            // Set IP Mode Value according to the selected profile
            //vm.bridge.ipMode.model = $filter('filter')(vm.ipModeList, { value: selectedProfile.ipMode }, true)[0];
            //setIpMode(vm.bridge.ipMode.model);
        }

        function changeModoRouted() {
            vm.bridge.ipProfile.model = '';
            vm.bridge.ipAddress.value = '';
        }

        // Set the IP Mode selected
        function setIpMode(selectedIpMode) {
            var ipProfile = vm.bridge.ipProfile.model;

            // Clear or sets IP Address, Subnet Mask and Gateway according to the selected IP Mode
            switch (selectedIpMode.value) {
                case 'STATIC':
                    // IP Address is empty and enabled
                    vm.bridge.ipAddress.value = '';
                    vm.bridge.ipAddress.disabled = false;

                    // Subnet Mask is empty and enabled
                    vm.bridge.subnetMask.value = ipProfile.subnetMask || '';
                    vm.bridge.subnetMask.disabled = isOlt8820G(); // Disabled for Zhone

                    // Gateway is empty and enabled
                    vm.bridge.gateway.value = ipProfile.gateway || '';
                    vm.bridge.gateway.disabled = isOlt8820G(); // Disabled for Zhone

                    break;

                case 'DHCP':
                    // IP Address is set and disabled
                    vm.bridge.ipAddress.value = isOlt8820G() ? '0.0.0.0' : ipProfile.ipAddress;
                    vm.bridge.ipAddress.disabled = true;

                    // Subnet Mask is empty and disabled
                    vm.bridge.subnetMask.value = ipProfile.subnetMask;
                    vm.bridge.subnetMask.disabled = true;

                    // Gateway is empty and disabled
                    vm.bridge.gateway.value = ipProfile.gateway;
                    vm.bridge.gateway.disabled = true;
            }
        }

        function setUniPort(index) {
            vm.showAlertVisible = false;
            vm.showAlertMessage = '';

            /*
             if(isOlt8820i() && vm.bridge.rgMode.model.value != '' && portObjectToArray(vm.bridge.lanPort.model).length > 1)  {
             vm.showAlertVisible = true;
             vm.showAlertMessage = ' A quantidade de portas não pode ser maior do que uma neste caso.';
             vm.bridge.lanPort.model[index] = false;
             return;
             }
             */
            if (isOlt8820i() && vm.bridge.onu.model && portObjectToArray(vm.bridge.lanPort.model).length > 1) {
                vm.bridge.gemPort.automatic = true;
                vm.bridge.gemPort.automaticDisabled = true;
                vm.bridge.name.maxlength = 56;
            } else {
                vm.bridge.gemPort.automaticDisabled = false;
                vm.bridge.name.maxlength = 60;
            }
            $translate('tooltip.name', vm.bridge.name).then(setTooltip('name'));
        }

        function checkGtp(interfaceModel) {
            var deferred = $q.defer();
            if (interfaceModel == 'ONU' && isOlt8820i()) {
                OltService.getOlt(vm.bridge.olt.model.id).then(function (data) {
                    if (!data.gtpCpeMgrId) {
                        OltService.gtpCpeMgrModalConstructor(vm.bridge.olt.model.id, $scope, true);
                        deferred.resolve(false);
                    }
                    deferred.resolve(true);
                });
            } else {
                deferred.resolve(true);
            }
            return deferred.promise;
        }

        function initialize() {
            vm.showAlertVisible = false;
            vm.showAlertMessage = '';

            vm.bridge = {
                name: {value: '', maxlength: 60},
                interface: {value: 'OLT', disabled: false},
                olt: {model: '', disabled: false},
                port: {model: '', disabled: true, placeholder: 'bridgeModal.placeholder.selectOlt'},
                onu: {model: '', disabled: true, placeholder: 'bridgeModal.placeholder.selectOltAndPort'},
                gemPort: {value: '', automatic: true, automaticDisabled: false},
                type: {label: 'Uplink', value: 'UPLINK'},
                vlanMode: 'untagged',
                vlan: {value: ''},
                cos: '',
                outcosall: '',
                slan: {value: ''},
                scos: '',
                soutcosall: '',
                service: 'data',
                video: {disabled: false},
                voice: {disabled: true},
                igmpProxy: {value: false, disabled: true},
                igmpSendIp: {value: '', disabled: true},
                multicastList: {model: '', disabled: true},
                maxMulticastStreams: {value: '', disabled: true},
                iPacketRule: {model: '', disabled: true},
                ePacketRule: {model: '', disabled: true},
                macLimit: '',
                gtp: {model: '', automatic: true, disabled: true},
                onuInterface: {disabled: true, hidden: true},
                rgMode: {model: {label: 'OMCI', value: ''}, disabled: true},
                ipProfile: {model: '', disabled: true},
                ipMode: {model: '', disabled: true},
                ipAddress: {value: '', disabled: true, required: false},
                subnetMask: {value: '', disabled: true, required: false},
                gateway: {value: '', disabled: true, required: false},
                user: '',
                password: '',
                lanPort: {model: {1: true, 2: true, 3: true, 4: true}, disabled: true},
                wlan: {model: {1: true, 2: false, 3: false, 4: false}, disabled: true},
                uniVlanMode: 'untagged',
                uniVlan: '',
                uniSlan: '',
                serverProfile: '',
                featuresProfile: '',
                mediaProfile: '',
                zhoneFeatures: '',
                fxs: [1, 2].map(function (index) {
                    return {
                        portNumber: index,
                        enablePort: false,
                        dialNumber: '',
                        username: '',
                        password: '',
                        rxGain: 0,
                        txGain: 0,
                        //serverProfile: '',
                        //featuresProfile: '',
                        //mediaProfile: '',
                        //zhoneFeatures: '',
                        get invalid() {
                            var form = vm.formAddBridge;
                            if (form.$submitted) {
                                for (var prop in form) {
                                    /* eslint-disable angular/controller-as-vm */
                                    if (prop.indexOf('fxs' + this.portNumber) > -1 && form[prop].$invalid) {
                                        return true;
                                    }
                                    /* eslint-enable angular/controller-as-vm */
                                }
                            }
                            return false;
                        }
                    };
                }),
                profiles: {placeholder: 'global.common.loading'},
                stp: {value: false, disabled: false}
            };

            vm.fxsCredentials = {pattern: '', username: {tooltip: ''}, password: {tooltip: ''}};

            disableSave();

            // Group all requests promises to enable save button only when all are resolved
            var promises = [
                BridgeService.getTypes().then(setList('typesList')),
                BridgeService.getPorts().then(setList('portList')),
                BridgeService.getRgModesOLT8820G().then(setList('rgModeList')),
                BridgeService.getIpModes().then(setList('ipModeList'))
            ];


            // Check if there is data coming from simple add modal
            if (vm.fromSimple) {
                // Get the values from simple add form

                for (var key in bridgeData) {
                    vm.bridge[key] = bridgeData[key];
                }
                // Get OLT and ONU info to enable/disable ONU Interface fields
                promises.push(getOltAndOnuInfo(vm.bridge.olt.model.id));

                // Show the ONU Interface column
                vm.bridge.onuInterface.hidden = false;

                // Change the size of the modal in order to show the "ONU Interface" column
                vm.modalSize = 'modal-xl';
            } else if (!vm.isEdit) {
                promises.push(OltService.listOlts().then(setList('oltList')));
            }

            if (vm.isEdit) {
                promises.push(
                    BridgeService.getBridge(bridgeId)
                        .then(successBridge)
                        .catch(errorBridge)
                );
            }

            // Enable save button only when all promises are resolved
            $q.all(promises).then(enableSave);
        }

        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function save(openOnuSettings) {
            if (!vm.formAddBridge.$valid) {
                vm.showAlertVisible = true;
                vm.showAlertMessage = ' Todos os campos em vermelho são obrigatórios.';
                return;
            }

            if ((isOnu121w() || isOnu120ac() || isOnu121ac() || isOnu1200r() || isOnuax1800() || isOnuax1800v() || isOnu142nw() || isOnuR1()) && !vm.bridge.lanPort.disabled && portObjectToArray(vm.bridge.lanPort.model).length != 1) {
                vm.showAlertVisible = true;
                vm.showAlertMessage = ' Selecionar somente uma porta, quando a ONU selecionada for ITBS.';
                return;
            }

            if (vm.formAddBridge.$valid && !vm.requestRunning) {
                vm.showAlertVisible = false;
                vm.showAlertMessage = '';

                checkGtp(vm.bridge.interface.value).then(function (result) {
                    if (result) {
                        var data = {
                            name: vm.bridge.name.value.toUpperCase(),
                            oltId: vm.bridge.olt.model.id,
                            portNumber: vm.bridge.port.model.value,
                            portType: vm.bridge.port.model.type,
                            type: vm.bridge.type.value,
                            vlanMode: vm.bridge.vlanMode.toUpperCase(),
                            serviceType: vm.bridge.service.toUpperCase()
                        };

                        if (vm.bridge.id) {
                            data.id = vm.bridge.id;
                        }

                        if (vm.bridge.vlan.value !== '' && vm.bridge.vlan.value !== null) {
                            data.vlan = vm.bridge.vlan.value;
                        }
                        if (vm.bridge.cos !== '' && vm.bridge.cos !== null) {
                            data.cos = vm.bridge.cos;
                        }
                        if (vm.bridge.outcosall !== '' && vm.bridge.outcosall !== null) {
                            data.outcosall = vm.bridge.outcosall;
                        }

                        if (vm.bridge.vlanMode == 'stagged') {
                            if (vm.bridge.slan.value !== '' && vm.bridge.slan.value !== null) {
                                data.slan = vm.bridge.slan.value;
                            }
                            if (vm.bridge.scos !== '' && vm.bridge.scos !== null) {
                                data.scos = vm.bridge.scos;
                            }
                            if (vm.bridge.soutcosall !== '' && vm.bridge.soutcosall !== null) {
                                data.soutcosall = vm.bridge.soutcosall;
                            }
                        }

                        if (vm.bridge.iPacketRule.model.id) {
                            data.iPacketRuleGroupId = vm.bridge.iPacketRule.model.id;
                        }
                        if (vm.bridge.ePacketRule.model.id) {
                            data.ePacketRuleGroupId = vm.bridge.ePacketRule.model.id;
                        }

                        if (vm.bridge.macLimit !== '' && vm.bridge.macLimit !== null) {
                            data.maxUnicast = vm.bridge.macLimit;
                        }

                        switch (vm.bridge.interface.value) {
                            case 'OLT':
                                data.stp = vm.bridge.stp.value;

                                if (vm.bridge.service == 'video') {
                                    data.igmpProxy = vm.bridge.igmpProxy.value;

                                    if (vm.bridge.igmpSendIp.value) {
                                        data.igmpSendIp = vm.bridge.igmpSendIp.value;
                                    }
                                }

                                break;

                            case 'ONU':
                                data.onuId = vm.bridge.onu.model.id;
                                if (!vm.bridge.gemPort.automatic && vm.bridge.gemPort.value) {
                                    data.gem = vm.bridge.gemPort.value;
                                }

                                switch (vm.bridge.service) {
                                    case 'video':
                                        if (vm.bridge.multicastList.model.id) {
                                            data.multicastControlListId = vm.bridge.multicastList.model.id;
                                        }
                                        data.maxMulticastStreams = vm.bridge.maxMulticastStreams.value;
                                        break;
                                    case 'voice':
                                        data.fxs = vm.bridge.fxs.map(function (item, index) {
                                            var port = angular.copy(item);
                                            port.fxsPortNumber = index + 1;
                                            port.adminState = item.enablePort ? 'UP' : 'DOWN';
                                            delete port.enablePort;
                                            return port;
                                        });
                                        data.cpeVoipProfile = {
                                            index: vm.cpeVoipIpProfile.index,
                                            profileName: vm.cpeVoipIpProfile.profileName,
                                            gateway: vm.cpeVoipIpProfile.gateway
                                        };

                                        if (vm.serverProfile) {
                                            data.serverProfile = vm.serverProfile;
                                        }
                                        if (vm.featuresProfile) {
                                            data.featuresProfile = vm.featuresProfile;
                                        }
                                        if (vm.mediaProfile) {
                                            data.mediaProfile = vm.mediaProfile;
                                        }
                                        if (vm.profileFeature) {
                                            data.profileFeature = vm.profileFeature;
                                        }
                                        if (vm.zhoneFeatures) {
                                            data.zhoneFeatures = vm.zhoneFeatures;
                                        }
                                }

                                if (!vm.bridge.gtp.automatic && vm.bridge.gtp.model.id) {
                                    data.gponTrafficProfileId = vm.bridge.gtp.model.id;
                                }

                                if (!vm.bridge.onuInterface.hidden) {
                                    if (!vm.bridge.rgMode.disabled && vm.bridge.rgMode.model.value) {
                                        data.rgMode = vm.bridge.rgMode.model.value;

                                        switch (data.rgMode) {
                                            case 'RG_BROUTED':
                                                if (vm.bridge.ipProfile.model) {
                                                    data.ipProfile = vm.bridge.ipProfile.model.profileName;
                                                    data.ipMode = vm.bridge.ipProfile.model.modo;
                                                    if (vm.bridge.ipProfile.model.modo == 'STATIC') {
                                                        data.ipAddress = vm.bridge.ipAddress.value;
                                                    }
                                                    data.subnetMask = vm.bridge.ipProfile.model.netmask;
                                                    data.gateway = vm.bridge.ipProfile.model.gateway;
                                                }
                                                /*
                                                 if(vm.bridge.ipProfile.model.name) { data.ipProfile = vm.bridge.ipProfile.model.name }
                                                 if(vm.bridge.ipMode.model.value) { data.ipMode = vm.bridge.ipMode.model.value }
                                                 if(vm.bridge.ipAddress.value) {
                                                 if(vm.bridge.ipMode.model.value == 'STATIC') {
                                                 data.ipAddress = vm.bridge.ipAddress.value;
                                                 }
                                                 }
                                                 if(vm.bridge.subnetMask.value) { data.subnetMask = vm.bridge.subnetMask.value }
                                                 if(vm.bridge.gateway.value) { data.gateway = vm.bridge.gateway.value }
                                                 */
                                                break;

                                            case 'RG_BPPPOE':
                                                data.pppoeUser = vm.bridge.user;
                                                data.pppoePassword = vm.bridge.password;
                                                break;
                                        }
                                    }

                                    if (!vm.bridge.lanPort.disabled) {
                                        var lanPorts = portObjectToArray(vm.bridge.lanPort.model);
                                        if (lanPorts.length) {
                                            data.lanPorts = lanPorts;
                                        }
                                    }

                                    if (!vm.bridge.onuInterface.disabled) {
                                        var wlanAps = portObjectToArray(vm.bridge.wlan.model);
                                        if (!vm.bridge.wlan.disabled && wlanAps.length) {
                                            data.wlanAps = wlanAps;
                                        }

                                        if (vm.bridge.uniVlanMode != 'untagged') {
                                            data.uniVlan = vm.bridge.uniVlan;
                                        }
                                        if (vm.bridge.uniVlanMode == 'stagged') {
                                            data.uniSlan = vm.bridge.uniSlan;
                                        }
                                    }
                                }
                                data.meProfile = vm.bridge.onu.model.meProfile;
                        }
                        if (data.id) {
//                            console.log("update bridge: ", data);
                            var dataAction = {
                                action: 'update',
                                methodService: 'updateBridge',
                                methodExtra: successSave(openOnuSettings, 'update'),
                                closeOnSuccess: openOnuSettings,
                                noSuccessMessage: true
                            };
                            BridgeService.confirmationModalConstructor(data, dataAction);
                        } else {
//                            console.log("add new bridge: ", data);
                            disableSave();
                            BridgeService.addBridge(data)
                                .then(successSave(openOnuSettings, 'add'))
                                .catch(errorAdd);
                        }
                    }
                });
            }
        }

        // Requests Callbacks
        function successBridge(data) {
            vm.bridge.id = data.id;
            vm.bridge.name.value = data.name;
            vm.bridge.interface.value = data.onuId ? 'ONU' : 'OLT';
            vm.bridge.interface.disabled = true;
            vm.bridge.vlanMode = data.vlanMode.toLowerCase();
            vm.bridge.service = data.serviceType.toLowerCase();

            vm.bridge.olt.model = {
                id: data.oltId,
                name: data.oltName
            };

            vm.bridge.port.model = $filter('filter')(
                vm.portList[vm.bridge.interface.value],
                {value: data.portNumber, type: data.portType},
                true
            )[0];

            if (data.vlan != null) {
                vm.bridge.vlan.value = data.vlan;
            }
            if (data.cos != null) {
                vm.bridge.cos = data.cos;
            }
            if (data.outcosall != null) {
                vm.bridge.outcosall = data.outcosall;
            }

            if (vm.bridge.vlanMode == 'stagged') {
                if (data.slan != null) {
                    vm.bridge.slan.value = data.slan;
                }
                if (data.scos != null) {
                    vm.bridge.scos = data.scos;
                }
                if (data.soutcosall != null) {
                    vm.bridge.soutcosall = data.soutcosall;
                }
            }

            PacketRuleService.listGroups(data.oltId)
                .then(function (result) {
                    successPacketRuleList(result);
                    if (data.iPacketRuleGroupId) {
                        vm.bridge.iPacketRule.model = $filter('filter')(vm.packetRuleList, {id: data.iPacketRuleGroupId}, true)[0];
                    }
                    if (data.ePacketRuleGroupId) {
                        vm.bridge.ePacketRule.model = $filter('filter')(vm.packetRuleList, {id: data.ePacketRuleGroupId}, true)[0];
                    }
                })
                .catch(close);

            if (data.maxUnicast != null) {
                vm.bridge.macLimit = data.maxUnicast;
            }

            getOltInfo(data.oltId).then(function () {
                vm.bridge.type = $filter('filter')(vm.typesList[vm.bridge.interface.value], {value: data.type}, true)[0];
                setType(vm.bridge.type);

                switch (vm.bridge.interface.value) {
                    case 'OLT':
                        vm.bridge.stp.value = data.stp;

                        if (vm.bridge.service == 'video') {
                            vm.bridge.igmpProxy.value = data.igmpProxy;
                            vm.bridge.igmpSendIp.disabled = false;

                            if (data.igmpSendIp) {
                                vm.bridge.igmpSendIp.value = data.igmpSendIp;
                            }
                        }

                        vm.modalSize = '';

                        break;

                    case 'ONU':
                        vm.bridge.onu.model = {id: data.onuId, name: data.onuName};

                        if (data.gem) {
                            vm.bridge.gemPort.value = data.gem;
                            vm.bridge.gemPort.automatic = false;
                        }

                        switch (vm.bridge.service) {
                            case 'video':
                                getMulticastLists(data.oltId).then(function () {
                                    if (data.multicastControlListId) {
                                        vm.bridge.multicastList.model = $filter('filter')(
                                            vm.multicastList,
                                            {id: data.multicastControlListId},
                                            true
                                        )[0];
                                        setMcl();
                                    }
                                });
                                vm.bridge.maxMulticastStreams.value = data.maxMulticastStreams;
                                break;
                            case 'voice':
                                if (data.serverProfile) {
                                    vm.serverProfile = data.serverProfile;
                                }
                                if (data.featuresProfile) {
                                    vm.featuresProfile = data.featuresProfile;
                                }
                                if (data.mediaProfile) {
                                    vm.mediaProfile = data.mediaProfile;
                                }
                                if (data.profileFeature) {
                                    vm.profileFeature = data.profileFeature;
                                }
                                if (data.zhoneFeatures) {
                                    vm.zhoneFeatures = data.zhoneFeatures;
                                }

                                if (data.fxs) {
                                    data.fxs.forEach(function (port, index) {
                                        var model = vm.bridge.fxs[index];
                                        model.portNumber = port.fxsPortNumber;
                                        model.enablePort = port.adminState == 'UP';
                                        model.dialNumber = port.dialNumber;
                                        model.username = port.username;
                                        model.password = port.password;
                                        model.rxGain = port.rxGain;
                                        model.txGain = port.txGain;
                                        //model.serverProfile = port.serverProfile;
                                        //model.featuresProfile = port.featuresProfile;
                                        //model.mediaProfile = port.mediaProfile;
                                        //model.zhoneFeatures = port.zhoneFeatures;
                                    });
                                }

                                vm.enderecoIp = data.cpeVoipProfile.gateway;
                        }

                        getGtpList(data.oltId).then(function () {
                            if (data.gponTrafficProfileId) {
                                vm.bridge.gtp.model = $filter('filter')(vm.gtpList, {id: data.gponTrafficProfileId}, true)[0];
                                vm.bridge.gtp.automatic = false;
                                vm.bridge.gtp.disabled = false;
                            }
                        });

                        getOnuInfo({oltId: data.oltId, name: data.onuName}).then(function () {
                            if (vm.bridge.service != 'voice') {
                                if (data.rgMode) {
                                    vm.bridge.rgMode.model = $filter('filter')(vm.rgModeList, {value: data.rgMode}, true)[0];

                                    setRgMode(vm.bridge.rgMode.model).then(function () {
                                        switch (data.rgMode) {
                                            case 'RG_BROUTED':
                                                var routedSelected = {
                                                    modo: data.ipMode,
                                                    profileName: data.ipProfile,
                                                    gateway: data.gateway,
                                                    netmask: data.subnetMask
                                                };

                                                vm.bridge.ipProfile.model = routedSelected;

                                                if (vm.bridge.ipProfile.model.modo == 'STATIC') {
                                                    vm.bridge.ipAddress.value = data.ipAddress;
                                                }

                                                if (data.ipMode == 'DHCP') {
                                                    vm.bridge.ipMode.model = vm.cpeVoipIpProfileList[0];
                                                } else {
                                                    vm.bridge.ipMode.model = vm.cpeVoipIpProfileList[1];
                                                }

                                                //vm.bridge.ipProfile.model = $filter('filter')(vm.cpeVoipIpProfileList, { name: data.ipProfile }, true)[0];
                                                //console.log( vm.bridge.ipProfile.model);

                                                /*
                                                 if(data.ipProfile) {
                                                 vm.bridge.ipProfile.model = $filter('filter')(vm.ipProfileList, { name: data.ipProfile }, true)[0];
                                                 if(!isOnuUnknown()) {
                                                 setProfile(vm.bridge.ipProfile.model);
                                                 }
                                                 }
                                                 
                                                 
                                                 
                                                 if(data.ipMode) {
                                                 vm.bridge.ipMode.model = $filter('filter')(vm.ipModeList, { value: data.ipMode }, true)[0];
                                                 if(!isOnuUnknown()) {
                                                 setIpMode(vm.bridge.ipMode.model);
                                                 }
                                                 
                                                 if(data.ipAddress) { vm.bridge.ipAddress.value = data.ipAddress }
                                                 if(data.subnetMask) { vm.bridge.subnetMask.value = data.subnetMask }
                                                 if(data.gateway) { vm.bridge.gateway.value = data.gateway }
                                                 }
                                                 */

                                                break;

                                            case 'RG_BPPPOE':
                                                if (data.pppoeUser) {
                                                    vm.bridge.user = data.pppoeUser;
                                                }
                                                if (data.pppoePassword) {
                                                    vm.bridge.password = data.pppoePassword;
                                                }
                                        }
                                    });
                                } else {
                                    vm.bridge.rgMode.model = {label: 'OMCI', value: ''};
                                    setRgMode(vm.bridge.rgMode.model);
                                }
                            }
                        });

                        if (data.lanPorts) {
                            vm.bridge.lanPort.model = portArrayToObject(data.lanPorts);
                        } else {
                            for (var port in vm.bridge.lanPort.model) {
                                vm.bridge.lanPort.model[port] = false;
                            }
                        }

                        if (data.wlanAps) {
                            vm.bridge.wlan.model = portArrayToObject(data.wlanAps);
                        } else {
                            for (var ap in vm.bridge.wlan.model) {
                                vm.bridge.wlan.model[ap] = false;
                            }
                        }

                        vm.bridge.uniVlanMode = 'untagged';
                        if (data.uniVlan != null) {
                            vm.bridge.uniVlan = data.uniVlan;
                            vm.bridge.uniVlanMode = 'tagged';
                        }
                        if (data.uniSlan != null) {
                            vm.bridge.uniSlan = data.uniSlan;
                            vm.bridge.uniVlanMode = 'stagged';
                        }

                        // Show the ONU Interface column
                        vm.bridge.onuInterface.hidden = false;

                        // Change the size of the modal in order to show/hide the "ONU Interface" column
                        vm.modalSize = 'modal-xl';
                }
            });
        }

        // Get OLT and ONU info to enable/disable ONU Interface fields
        function getOltAndOnuInfo(oltId) {
            return getOltInfo(oltId).then(function (olt) {
                return getOnuInfo({oltId: olt.id, name: vm.bridge.onu.model.name});
            });
        }

        function getOltInfo(oltId) {
            return OltService.getOlt(oltId).then(function (olt) {
                vm.bridge.olt.model.model = olt.model;
                setOlt(olt);
                return olt;
            });
        }

        function getOnuInfo(data) {
            return OnuService.getAuthorizedOnuList(data).then(function (onuList) {
                vm.bridge.onu.model.meProfile = onuList.data.content[0].meProfile;
                setOnu(onuList.data.content[0], null);
            });
        }

        function errorBridge(response) {
            enableSave();
            BridgeService.errorModalConstructor(response, 'get');
            close();
        }

        // Load GTP list according to the selected OLT
        function getGtpList(oltId, hideLoader) {
            vm.bridge.gtp.disabled = true;
            return GtpService.listGtp({oltId: oltId}, hideLoader)
                .then(setList('gtpList'))
                .catch(close);
        }

        // Load MCL list according to the selected OLT
        function getMulticastLists(oltId, hideLoader) {
            vm.bridge.multicastList.disabled = true;
            return BridgeService.getMulticastLists({oltId: oltId}, hideLoader)
                .then(setList('multicastList'))
                .catch(close);
        }

        function getIpProfiles(oltId) {
            BridgeService.getCpeVoipProfiles(vm.bridge.olt.model.id, vm.bridge.olt.model.model)
                .then(successCpeVoipProfilesList)
                .catch(function () {
                    enableSave();
                    close();
                });

            if (isOlt8820G()) {
                disableSave();
                vm.bridge.ipProfile.disabled = true;
                vm.bridge.ipProfile.placeholder = 'global.common.loading';
                return BridgeService.getIpProfiles(oltId)
                    .then(function (data) {
                        enableSave();
                        if (!isOnuUnknown()) {
                            vm.bridge.ipProfile.disabled = false;
                        }
                        vm.bridge.ipProfile.placeholder = '';
                        //setList('ipProfileList')(data);
                        //setList('ipProfileList')(data);
                        vm.featuresProfileList = data.profilesIndexConfiguracaoDinamico;
                        vm.featuresStaticProfileList = data.profilesIndexConfiguracaoEstatico;
                    })
                    .catch(function () {
                        enableSave();
                        close();
                    });
            }
            return $q.resolve();
        }

        // Request callbacks
        function successOnuList(data) {
            enableSave();
            if (data.data.length) {
                vm.onuList = data.data;
                vm.bridge.onu.disabled = false;
                vm.bridge.onu.placeholder = 'global.common.select';
            } else {
                vm.bridge.onu.placeholder = 'bridgeModal.placeholder.noOnuFound';
                vm.bridge.rgMode.model = {label: 'OMCI', value: ''};
                vm.bridge.lanPort.disabled = true;
                vm.bridge.wlan.disabled = true;
                vm.bridge.onuInterface.disabled = true;
                vm.bridge.rgMode.disabled = true;
            }
        }

        function successPacketRuleList(data) {
            vm.packetRuleList = data;
            vm.bridge.iPacketRule.disabled = !data.length;
            vm.bridge.ePacketRule.disabled = !data.length;
        }

        function successSipProfilesList(data) {
            enableSave();

            vm.serverProfileList = data.profilesIndexServidor;

            vm.featuresProfileList = data.profilesIndexConfiguracaoDinamico;
            vm.featuresStaticProfileList = data.profilesIndexConfiguracaoEstatico;

            vm.mediaProfileList = data.profilesIndexMedia;
            vm.zhoneFeaturesList = data.profilesFeature;

            //vm.serverProfileList = data.server;
            //vm.featuresProfileList = data.features;
            //vm.mediaProfileList = data.media;
            vm.bridge.profiles.placeholder = '';
        }

        function successCpeVoipProfilesList(data) {
            enableSave();
            vm.cpeVoipIpProfileList = data;

            if (vm.enderecoIp != '' && vm.enderecoIp != '0.0.0.0')
                vm.cpeVoipIpProfile = data[1];
            else
                vm.cpeVoipIpProfile = data[0];
        }

        function successSave(openOnuSettings, action) {
            var onuData = {
                id: vm.bridge.onu.model.id,
                oltId: vm.bridge.olt.model.id
            };

            return function (response) {
                enableSave();

                if (openOnuSettings) {
                    if (response.status == 207) {
                        // When response status is 207, the config modal must open only after the warning modal is closed
                        var modalWarningInstance = BridgeService.warningModalConstructor(response.data, response, action, true);
                        modalWarningInstance.closed.then(function () {
                            openOnuConfig(onuData, response, action);
                        });
                    } else {
                        // When response status is 200, the config modal must be open
                        openOnuConfig(onuData, response, action);
                    }
                } else {
                    var modalInstance;
                    if (response.status == 207) {
                        // For response status 207 opens the warning modal
                        modalInstance = BridgeService.warningModalConstructor(response.data, response, action);
                    } else {
                        // For response status 200 opens the success modal
                        modalInstance = BridgeService.successModalConstructor(action, response.data.length > 1);
                    }
                    // Update the list when success/warning modal is closed
                    modalInstance.result.finally(updateList(response, action));
                }
            };
        }

        function openOnuConfig(onuData, response, action) {
            var modalInstance = OnuService.configOnuModalConstructor(onuData, false);
            modalInstance.result.finally(updateList(response, action));
        }

        function updateList(response, action) {
            return function () {
                if (response.status == 207) {
                    // Always clean filter when response status is 207
                    $rootScope.$emit('cleanFilter', true);
                } else {
                    // Emmit event to update list (adding and/or updating the bridges)
                    var actionEvent = action.charAt(0).toUpperCase() + action.slice(1);
                    $rootScope.$emit('bridge' + actionEvent + 'Success', response.data);

                    if (isOlt8820G() && vm.bridge.stp.value) {
                        // Always clean filter if bridge is STP in 8820G
                        $rootScope.$emit('cleanFilter', true);
                    } else if (action == 'add') {
                        // Only emmit the clean event when adding
                        $rootScope.$emit('cleanFilter');
                    }
                }
            };
        }

        $uibModalInstance.closed.then(function () {
            $rootScope.$emit('bridgeClosed');
        });

        var clearListener = $rootScope.$on('onuConfigLoaded', close);
        $scope.$on('$destroy', clearListener);

        function errorAdd(response) {
            enableSave();
            BridgeService.errorModalConstructor(response, 'add');
        }

        // Utilities
        function disableSave() {
            vm.requestRunning = true;
        }

        function enableSave() {
            vm.requestRunning = false;
        }

        function resetSelectIndex(viewSelectReference) {
            selectReference[viewSelectReference].activeIndex = 0;
        }

        function setSelectReference(viewSelectReference, $select) {
            selectReference[viewSelectReference] = $select;
        }

        // Return a function that set the content of the defined list (used in comboboxes) when the promise is resolved
        function setList(list) {
            return function (data) {
                vm[list] = data;
            };
        }

        function partial(block) {
            return 'app/components/bridge/partials/bridge-config-' + block + '.html';
        }

        // Convert lan ports object (used in model) to array (used in request)
        // { 1: true, 2: false, 3: true, 4: true } -> [1, 3, 4]
        function portObjectToArray(obj) {
            return Object.keys(obj)
                .filter(function (key) {
                    return obj[key];
                })
                .map(Number);
        }

        // Convert lan ports array (used in request) to object (used in model)
        // [1, 3, 4] -> { 1: true, 2: false, 3: true, 4: true }
        function portArrayToObject(array) {
            var obj = {};
            for (var i = 1; i <= 4; i++) {
                obj[i] = array.indexOf(i) > -1;
            }
            return obj;
        }

        function isOlt8820G() {
            return vm.bridge.olt.model.model != 'Intelbras8820i';
        }

        function isOlt8820i() {
            return vm.bridge.olt.model.model == 'Intelbras8820i';
        }

        function isOnu110() {
            return vm.bridge.onu.model.meProfile == 'intelbras-110';
        }

        function isOnu110G() {
            return vm.bridge.onu.model.meProfile == 'intelbras-110g' || vm.bridge.onu.model.meProfile == 'intelbras-110b' || vm.bridge.onu.model.meProfile == 'intelbras-110gb';
        }

        function isOnu110Gi() {
            return vm.bridge.onu.model.meProfile == 'intelbras-110gi';
        }

        function isOnu120ac() {
            return vm.bridge.onu.model.meProfile == 'intelbras-120ac';
        }

        function isOnu121ac() {
            return vm.bridge.onu.model.meProfile == 'intelbras-121ac';
        }

        function isOnu121w() {
            return vm.bridge.onu.model.meProfile == 'intelbras-121w';
        }

        function isOnu1200r() {
            return vm.bridge.onu.model.meProfile == 'intelbras-1200r';
        }

        function isOnu1420g() {
            return vm.bridge.onu.model.meProfile == 'intelbras-1420g';
        }
        function isOnuax1800() {
            return vm.bridge.onu.model.meProfile == 'intelbras-ax1800';
        }
        function isOnuax1800v() {
            return vm.bridge.onu.model.meProfile == 'intelbras-ax1800v';
        }
        function isOnu142nw() {
            return vm.bridge.onu.model.meProfile == 'intelbras-142nw';
        }

        function isOnuDefault() {
            return vm.bridge.onu.model.meProfile == 'intelbras-default';
        }

        function isOnuR1() {
            return vm.bridge.onu.model.meProfile == 'intelbras-r1';
        }

        function isOnuUnknown() {
            return vm.bridge.onu.model.meProfile == '--';
        }

        function checkRgMode(rgMode) {
            return vm.bridge.rgMode.model.value == rgMode;
        }

        function isWifi() {
            return false;
            //return vm.bridge.wlan.disabled == false;
        }

        function isLanPortDisabled(index) {
            //vm.bridge.rgMode.model.value != '' && vm.bridge.rgMode.model.value != 'RG_BROUTED_ITBS'

            if (!vm.bridge.lanPort.disabled) {
                if ((isOnu110() || isOnu110G() || isOnu110Gi() || isOnuR1()) && index != 1) {
                    return true;
                }
                if ((isOnu121w() || isOnu120ac() || isOnu121ac() || isOnu1200r()) && index != 1 && index != 2) {
                    return true;
                }
            } else {
                return vm.bridge.lanPort.disabled;
            }
        }

        function setTooltip(input) {
            return function (translation) {
                vm.bridge[input].tooltip = translation;
            };
        }

        function setFxsTooltip(input) {
            return function (translation) {
                vm.fxsCredentials[input].tooltip = translation;
            };
        }

        function isStpDisabled() {
            vm.bridge.stp.disabled = false;
            if (vm.bridge.interface.value == 'OLT' && isOlt8820i()) {
                vm.bridge.stp.disabled = true;
                if (vm.bridge.stp.value)
                    vm.bridge.stp.value = false;
            }
            return vm.bridge.stp.disabled;
        }
    }
})();
